import {TFunction} from '@deviceinsight/ng-ui-scale-lib/api';
import {memoize} from 'lodash';

const isBoolean = (val: string | boolean | null | undefined) => !!val === val;

export const getDisplayValue = (value: string | boolean | null | undefined, unit?: string): string => {
	const unitDisplay = unit ? ` ${unit}` : '';

	if (isBoolean(value)) {
		return value ? 'true' : 'false';
	} else if (typeof value !== 'undefined' && value != null) {
		return `${value}${unitDisplay}`;
	}

	return `--${unitDisplay}`;
};
export const NO_VALUE_DISPLAY = '--';
export const formatNumber = (
	value: number | null | undefined,
	fractionDigits: number,
	grouping?: boolean,
	unit?: string,
	fallback?: string
): string => {
	if (value === undefined || value === null || isNaN(value)) {
		return fallback || '';
	} else {
		const options = {
			minimumFractionDigits: fractionDigits,
			maximumFractionDigits: fractionDigits,
			useGrouping: grouping || false
		};
		const formatted = value.toLocaleString('de-DE', options);

		if (unit !== null && unit !== undefined) {
			return `${formatted} ${unit}`;
		} else {
			return formatted;
		}
	}
};
const TRANSLATION_REGEX = /##(.*?)##/g;
export const translateCustomTokens = memoize((content: string, t: TFunction): string => {
	let match = TRANSLATION_REGEX.exec(content);
	let translatedContent = content;

	while (match && match.length) {
		translatedContent = translatedContent.replace(match[0], t(match[1]));
		match = TRANSLATION_REGEX.exec(content);
	}

	return translatedContent;
});
